import React from 'react';
import { GraduationCap } from 'lucide-react';
import { Button } from '../ui/button';
import { useTutorial } from '../../contexts/TutorialContext';
import { cn } from '../../lib/utils';

export default function TutorialLauncher({ className }) {
  const {
    state,
    canResume,
    startTutorial,
    isLoading,
    tutorialEnabledForOrg,
  } = useTutorial();

  // Don't show while loading, while tutorial is active, or if org disabled tutorials
  if (isLoading || state.isActive || !tutorialEnabledForOrg) return null;

  // Show if user can resume an in-progress tutorial
  if (!canResume) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => startTutorial()}
      className={cn('relative', className)}
      title="Resume Tutorial"
      aria-label="Resume Tutorial"
    >
      <GraduationCap className="w-5 h-5" />
      <span className="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full" />
    </Button>
  );
}
